import React, { useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { useOnUpdate } from 'js/customHooks'
import 'styles/controls/ParameterSwitch.sass';


//Cambiar a universeSwitch

export default function ObsCov() {
  const universes = useSelector((state) => state.universes);
  const universe = useSelector((state) => state.universe);
  const observations = useSelector((state) => state.observations);
  const dispatch = useDispatch();

  useEffect(() => { 
    console.log('render ObsCov')
  });

  return (
    <div id="parChartCont" className="table">
      <div className="row">
        <div className="cell">
          <div id="parCont" className="table">
            <div className="row relative">
                <div className="parItem cell covItem" onClick={() => {dispatch({ type: 'SET_OBSERVATIONS', payload: !observations})}} title="Open Charts">
                  <div id={'CovIcon'} className={universe + " " + (observations?"parItemSel":"parItemUnSel")} />
                </div>
                <div className="numObs">Number of observations</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
